module.exports = __webpack_public_path__ + "img/401.d920bf82.png";